/**
 * Generated by orval. Do not edit manually.
 */

export type SpotFrequencyMonthsEnum =
  (typeof SpotFrequencyMonthsEnum)[keyof typeof SpotFrequencyMonthsEnum]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpotFrequencyMonthsEnum = {
  NUMBER_1: 1,
  NUMBER_3: 3,
  NUMBER_6: 6,
  NUMBER_12: 12,
  NUMBER_24: 24,
} as const
